import Vue from 'vue'

export default {
    setQuickAccesses: (state, quickAccesses) => {
        Vue.set(state, 'quickAccesses', quickAccesses)
    },
    setQuickAccess: (state, quickAccess) => {
        Vue.set(state, 'quickAccess', quickAccess)
    },
    clearQuickAccesses: (state) => {
        Vue.set(state, 'quickAccesses', [])
    }
}
